export default "__VITE_ASSET__haXnaiC5__"